import React, { useEffect, useRef } from 'react';
import ButtonImage from '../../assets/Inicio/message.png';
import { motion, AnimatePresence } from 'framer-motion';
import ContactoServicios from '../ContactoServicios/ContactoServicios';

// Creamos un estado global para el modal
let modalRoot = null;
let cleanup = null;

// Función para abrir el modal desde cualquier componente
export const openContactModal = () => {
  if (!modalRoot) {
    modalRoot = document.createElement('div');
    modalRoot.id = 'contact-modal-root';
    document.body.appendChild(modalRoot);
  }

  const closeModal = () => {
    if (modalRoot && modalRoot.parentNode) {
      document.body.removeChild(modalRoot);
      modalRoot = null;
    }
  };

  cleanup = closeModal;
  return closeModal;
};

const ChatButton = ({ isOpen = false, setIsOpen, showTemaSelector = true }) => {
  const modalRef = useRef(null);

  const handleOpenModal = () => {
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
    if (cleanup) {
      cleanup();
    }
  };

  // Deshabilitar el scroll del body cuando el modal está abierto
  useEffect(() => {
    if (isOpen) {
      // Guardar la posición del scroll
      const scrollY = window.scrollY;

      // Bloquear el scroll del body sin usar position:fixed
      // que podría afectar a los componentes internos
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = '15px'; // Compensar la barra de scroll
      document.body.style.height = '100%';

      // Prevenir el scroll de la rueda del mouse solo fuera del modal
      const preventScroll = (e) => {
        // Verificar si el evento proviene del modal o cualquier elemento dentro de él
        if (modalRef.current && modalRef.current.contains(e.target)) {
          // Permitir scroll dentro del modal
          return true;
        }

        // Verificar si el evento proviene del dropdown de países
        const countryDropdown = document.getElementById('country-dropdown-portal');
        if (countryDropdown && countryDropdown.contains(e.target)) {
          // Permitir scroll dentro del dropdown de países
          return true;
        }

        // Si estamos fuera del modal y del dropdown, prevenir el scroll
        e.preventDefault();
        return false;
      };

      // Usar passive: false para poder llamar a preventDefault()
      window.addEventListener('wheel', preventScroll, { passive: false });
      window.addEventListener('touchmove', preventScroll, { passive: false });

      return () => {
        // Restaurar el scroll al desmontar
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        document.body.style.height = '';

        // Eliminar los event listeners
        window.removeEventListener('wheel', preventScroll);
        window.removeEventListener('touchmove', preventScroll);

        // Restaurar la posición de scroll
        window.scrollTo(0, scrollY);
      };
    } else {
      // Restaurar los estilos normales
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      document.body.style.height = '';
    }
  }, [isOpen]);

  return (
    <>
      {/* Botón flotante de soporte */}
      <button
        onClick={handleOpenModal}
        className="fixed bottom-4 right-6 z-50 transition-transform hover:scale-110"
      >
        <img
          src={ButtonImage}
          alt="Botón estático"
          className="w-10 h-10 md:w-auto md:h-10 rounded-full"
        />
      </button>

      {/* Modal de contacto */}
      <AnimatePresence>
        {isOpen && (
          <>
            {/* Overlay con blur */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[60]"
              onClick={handleCloseModal}
            />

            {/* Modal */}
            <motion.div
              ref={modalRef}
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              className="fixed inset-0 flex items-center justify-center z-[70]"
            >
              <div className="bg-white w-[95%] sm:w-[90%] md:w-[80%] lg:w-[60%] xl:w-[500px] max-h-[90vh] overflow-y-auto my-[2vh] md:my-[5vh] relative rounded-lg shadow-xl">
                {/* Botón de cerrar */}
                <button
                  onClick={handleCloseModal}
                  className="absolute top-3 right-3 md:top-6 md:right-6 text-[#152b5a] hover:text-[#1f3f85] z-[80] bg-white rounded-full p-1"
                >
                  <svg
                    className="w-5 h-5 md:w-6 md:h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>

                {/* Contenido del formulario */}
                <div className="w-full py-6 px-4 sm:py-8 sm:px-8 md:py-10 md:px-12 bg-white">
                  <ContactoServicios
                    isModal={true}
                    onClose={handleCloseModal}
                    showTemaSelector={showTemaSelector}
                  />
                </div>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default ChatButton;
